import { address } from './address.fixture';

export const companyPartialAddress = country => {
  const { street, postalCode } = address(country);
  return { street, postalCode, country: null, city: null };
};

export function companyDetailsStepConfig({ country }) {
  const companyDetails = {
    address: address(country),
    operatingAddress: address(country),
    companyName: 'Klarna Lmtd',
    country,
  };

  const partialCompanyDetails = {
    address: companyPartialAddress(country),
    operatingAddress: companyPartialAddress(country),
    companyName: '',
  };

  const partnershipDetails = {
    companyName: 'Klarna partnership',
    operatingAddress: address(country),
  };
  const partialPartnershipDetails = {
    companyName: '',
    operatingAddress: companyPartialAddress(country),
  };

  const operatingAddressSoleTrader = {
    operatingAddress: address(country),
  };

  const partialOperatingAddressSoleTrader = {
    operatingAddress: companyPartialAddress(country),
  };

  return {
    companyDetails: {
      value: companyDetails,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
    partialCompanyDetails: {
      value: partialCompanyDetails,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
    partnershipDetails: {
      value: partnershipDetails,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
    partialPartnershipDetails: {
      value: partialPartnershipDetails,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
    operatingAddressSoleTrader: {
      value: operatingAddressSoleTrader,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
    partialOperatingAddressSoleTrader: {
      value: partialOperatingAddressSoleTrader,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
  };
}
